<template>
  <div class="admin">
    <div v-if="isLoading" class="admin__loader">
      <span class="loader"></span>
    </div>
    <div v-else-if="isAuthenticated" class="admin__container">
      <AdminNavbar @open-preview="goToPreview"/>
      <div class="admin__page">
        <LeftSidebar @on-collapsed="handleCollapsedUpdated" :items="sideList" @select="handleSelectPage" :side="currentSideList"/>
        <Dashboard :side="currentSideList" :isCollapsed="isCollapsed"/>
      </div>
    </div>

    <div v-else class="admin__container">
      <LoginModal />
    </div>
  </div>
</template>

<script>
import Dashboard from '@/components/pages/admin/dashboard/index.vue'
import AdminNavbar from '@/components/UI/Sidebars/Navbar/AdminNavbar.vue'
import LoginModal from '@/components/pages/admin/profile/LoginModal.vue'
import LeftSidebar from '@/components/pages/admin/dashboard/LeftSidebar.vue'

export default {
  components: {
    Dashboard, AdminNavbar, LoginModal, LeftSidebar
  },
  data () {
    return {
      showLogin: true,
      currentSideList: { id: 0, icon: '📊', title: 'Статистика' },
      sideList: [
        { id: 0, icon: 'folder-eye', title: 'Статистика' },
        { id: 1, icon: 'calendar', title: 'Календарь' },
        { id: 2, icon: 'list', title: 'Заявки' },
        { id: 3, icon: 'seo', title: 'SEO' }
      ],
      isCollapsed: false,
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    },
    isLoading () {
      return this.$store.state.user.loading
    }
  },
  created() {
    // при монтировании запускаем инициализацию
    this.$store.dispatch('user/init')
  },
  methods: {
    handleCollapsedUpdated (isCollapsed) {
      this.isCollapsed = isCollapsed
    },
    handleSelectPage (item) {
      this.currentSideList = item
    },
    goToPreview() {
      this.$store.dispatch('activeElement/UPDATE_ACTIVE_ELEMENT', null)
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.admin__loader {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.loader {
  width: 3rem;  
  height: 3rem; 
  display: inline-block;
  position: relative;
}
.loader::after,
.loader::before {
  content: '';  
  box-sizing: border-box;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: #FFF;
  position: absolute;
  left: 0;
  top: 0;
  animation: animloader 2s linear infinite;
}

.loader::after {
  animation-delay: 1s;
  animation-fill-mode: both; /* чтобы сразу заняло исходное состояние */
}


@keyframes animloader {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.admin__page {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
</style>
